var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorksImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189.689,
    height: 169.123,
    viewBox: "0 0 189.689 169.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2984",
    "data-name": "Rectangle 2984",
    width: 189.689,
    height: 169.059,
    transform: "translate(0 -36)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22461",
    "data-name": "Group 22461",
    transform: "translate(-1407 -1669)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2985",
    "data-name": "Rectangle 2985",
    width: 189,
    height: 169,
    rx: 18,
    transform: "translate(1407 1669)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22232",
    "data-name": "Path 22232",
    d: "M1.051-2.106c1.676,0,33.721-.69,34.256.69C39.445.346,40.063,9.787,40.063,12.5c0,3.369-3.375,12.447-6.518,12.489-4.217.648-23.956,0-25.236,0-1.258,0-6.347,2.533-8.309,0C-1.56,22.983,0,15.931,0,12.5,0,5.6-1.711-2.106,1.051-2.106Z",
    transform: "translate(1431 1705)",
    fill: "#dd2228",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22460",
    "data-name": "Group 22460",
    transform: "translate(1407 1705.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22459",
    "data-name": "Group 22459",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22222",
    "data-name": "Path 22222",
    d: "M171.906,0H17.783C7.977,0,0,10.137,0,22.595V146.464c0,12.458,7.977,22.595,17.783,22.595H46.928a2.583,2.583,0,0,0,0-5.021H17.783c-7.626,0-13.832-7.884-13.832-17.574V22.595c0-9.69,6.206-17.574,13.832-17.574H171.906c7.626,0,13.832,7.884,13.832,17.574V146.464c0,9.69-6.206,17.574-13.832,17.574H90.478a2.583,2.583,0,0,0,0,5.021h81.428c9.806,0,17.783-10.137,17.783-22.595V22.595C189.689,10.137,181.713,0,171.906,0",
    transform: "translate(0 -36)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22223",
    "data-name": "Path 22223",
    d: "M190.688,344.451H177.47a1.976,1.976,0,1,0,0,3.952h13.218a1.976,1.976,0,1,0,0-3.952",
    transform: "translate(-109.715 -215.344)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22224",
    "data-name": "Path 22224",
    d: "M64.052,104.607H92.64a7.624,7.624,0,0,0,7.614-7.615V79.947a7.623,7.623,0,0,0-7.614-7.615H64.052a7.624,7.624,0,0,0-7.614,7.615V96.991a7.624,7.624,0,0,0,7.614,7.615M60.39,79.947a3.666,3.666,0,0,1,3.662-3.663H92.64A3.666,3.666,0,0,1,96.3,79.947V96.991a3.666,3.666,0,0,1-3.662,3.663H64.052a3.666,3.666,0,0,1-3.662-3.663Z",
    transform: "translate(-35.284 -77.221)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22225",
    "data-name": "Path 22225",
    d: "M334.761,76.282h39.864a1.976,1.976,0,1,0,0-3.952H334.761a1.976,1.976,0,0,0,0,3.952",
    transform: "translate(-208.051 -77.219)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22226",
    "data-name": "Path 22226",
    d: "M334.761,121.207h39.864a1.976,1.976,0,1,0,0-3.952H334.761a1.976,1.976,0,0,0,0,3.952",
    transform: "translate(-208.051 -105.306)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22227",
    "data-name": "Path 22227",
    d: "M58.415,231.892H98.279a1.976,1.976,0,1,0,0-3.952H58.415a1.976,1.976,0,1,0,0,3.952",
    transform: "translate(-35.285 -142.504)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22230",
    "data-name": "Path 22230",
    d: "M58.415,231.892H98.279a1.976,1.976,0,1,0,0-3.952H58.415a1.976,1.976,0,1,0,0,3.952",
    transform: "translate(-35.292 -159.059)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22228",
    "data-name": "Path 22228",
    d: "M58.415,276.061h91.13a1.976,1.976,0,1,0,0-3.952H58.415a1.976,1.976,0,1,0,0,3.952",
    transform: "translate(-35.285 -170.117)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22229",
    "data-name": "Path 22229",
    d: "M407.87,227.941H387.937a1.976,1.976,0,0,0,0,3.952H407.87a1.976,1.976,0,1,0,0-3.952",
    transform: "translate(-241.295 -142.504)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22231",
    "data-name": "Path 22231",
    d: "M407.87,227.941H387.937a1.976,1.976,0,0,0,0,3.952H407.87a1.976,1.976,0,1,0,0-3.952",
    transform: "translate(-241.303 -159.059)",
    fill: "#212121"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksImg3);
export default __webpack_public_path__ + "static/media/how-it-works-img-3.ca7f0e6f06252a82a3f3f461c33bc505.svg";
export { ForwardRef as ReactComponent };